(() => {
  if (window.arcBackgroundVideoReady) return;
  window.arcBackgroundVideoReady = true;
  const init = root => {
    if (root.arcBackgroundReady) return;
    root.arcBackgroundReady = true;
    const mobile = matchMedia('(max-width: 767px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let visible = root.getBoundingClientRect().bottom > 0 && root.getBoundingClientRect().top < innerHeight;
    const records = Array.from(root.querySelectorAll('video'), video => ({
      video,
      src: video.getAttribute('src'),
      sources: Array.from(video.querySelectorAll('source'), source => ({source,src:source.getAttribute('src')})),
      loaded: true
    }));
    function clear(record) {
      record.video.pause();
      if (!record.loaded) return;
      record.video.removeAttribute('src');
      record.sources.forEach(({source}) => source.removeAttribute('src'));
      record.video.load();
      record.loaded = false;
    }
    function sync() {
      const active = records.find(({video}) => !video.closest('.arc-band__v') || video.closest(mobile.matches ? '.arc-band__v--m' : '.arc-band__v--d'));
      records.forEach(record => {
        const video = record.video;
        if (record !== active) { clear(record); return; }
        if (!visible || document.hidden || reduced.matches) { video.pause(); return; }
        if (!record.loaded) {
          if (record.src) video.setAttribute('src',record.src);
          record.sources.forEach(({source,src}) => { if(src) source.setAttribute('src',src); });
          video.load();
          record.loaded = true;
        }
        video.muted = true;
        video.play().catch(() => {});
      });
    }
    records.forEach(record => { record.video.removeAttribute('autoplay'); clear(record); });
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => { visible = entries.some(entry => entry.isIntersecting); sync(); }, {threshold:0.01}) : null;
    observer?.observe(root);
    mobile.addEventListener('change',sync);
    reduced.addEventListener('change',sync);
    document.addEventListener('visibilitychange',sync);
    const section = root.closest('.shopify-section');
    const unload = event => {
      if (event.target !== section) return;
      observer?.disconnect();
      mobile.removeEventListener('change',sync);
      reduced.removeEventListener('change',sync);
      document.removeEventListener('visibilitychange',sync);
      document.removeEventListener('shopify:section:unload',unload);
      records.forEach(clear);
      records.forEach(record => {
        if (record.src) record.video.setAttribute('src',record.src);
        record.sources.forEach(({source,src}) => { if(src) source.setAttribute('src',src); });
      });
      root.arcBackgroundReady = false;
    };
    document.addEventListener('shopify:section:unload',unload);
    sync();
  };
  document.querySelectorAll('[data-arc-background-video]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-arc-background-video]').forEach(init);
  });
})();
